import { FormattedDate } from 'react-intl';

import styled from 'styled-components';

import { MemberDataExport, MemberDataExportStatus } from 'apps-common/types';
import { t } from 'translations/src/LocaleContext';
import { Background } from 'ui/styles/layout';
import { SmallText, Text } from 'ui/styles/text';

import { DownloadButton } from './DownloadButton';

const Item = styled(Background)(
  ({ theme }) => `
  color: ${theme.colors.white2};
  padding: 16px;
  display: flex;
  gap: 8px;

  &::before {
    content: '\\2022';
    font-size: 1.75em;
    color: ${theme.colors.lightRed}; 
    height: 0.75rem;
    line-height: 0.75rem;
  }
    
  &[data-status="pending"]::before {
    color: ${theme.colors.lightYellow};
  }

  &[data-status="ready"]::before {
    color: ${theme.colors.lightGreen};
  }

  > div {
   display: grid;
   gap: 8px;
   flex: 1;
  }

  h3 {
    display: flex;
    align-items: center;
  }
`,
);

const ExportOnLabel = ({ scheduledAt }: { scheduledAt: string }) => {
  return (
    <Text as="h3">
      {t('membership_hub_data_export_label', { date: <FormattedDate value={scheduledAt} format="default" /> })}
    </Text>
  );
};

export const ExportsListItem = (props: MemberDataExport) => {
  switch (props.status) {
    case MemberDataExportStatus.scheduled:
    case MemberDataExportStatus.processing:
      return (
        <Item data-status="pending">
          <div>
            <ExportOnLabel scheduledAt={props.createdAt} />
            <SmallText>{t('membership_hub_data_export_pending')}</SmallText>
          </div>
        </Item>
      );
    case MemberDataExportStatus.completed: {
      const { downloadUrlExpiresAt } = props;
      const isExpired = new Date(downloadUrlExpiresAt) < new Date();

      if (!isExpired) {
        return (
          <Item data-status="ready">
            <div>
              <ExportOnLabel scheduledAt={props.createdAt} />
              <SmallText>
                {t('membership_hub_data_export_available', {
                  date: <FormattedDate value={downloadUrlExpiresAt} format="default" />,
                })}
              </SmallText>
            </div>
            <DownloadButton dataExport={props} />
          </Item>
        );
      }

      return (
        <Item data-status="ready">
          <div>
            <ExportOnLabel scheduledAt={props.createdAt} />
            <SmallText>{t('membership_hub_data_export_expired')}</SmallText>
          </div>
        </Item>
      );
    }

    default:
      return (
        <Item data-status={props.status}>
          <div>
            <ExportOnLabel scheduledAt={props.createdAt} />
            <SmallText>{props.status}</SmallText>
          </div>
        </Item>
      );
  }
};
